<template>
<div class="Snake" :style="{width:(width+2)*10+'px'}">
  <div :class="val.type==1?'qiang':(val.l==red.l&&val.t==red.t)?'red':''" v-for="(val,key) in list" :key="key"></div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      width: 20,
      height: 20,
      list: [],
      msg: '',
      key: {
        type: 1,
        l: 0,
        t: 0
      },
      red: {
        l: 1,
        t: 1
      },
      Snake: [
        {l: 1, t: 1}
      ]
    }
  },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      this.list = []
      for (var a = 0; a < this.width + 2; a++) {
        for (var b = 0; b < this.height + 2; b++) {
          this.gethb(a, b)
        }
      }
      this.getred()
    },
    gethb (a, b) {
      var key = {
        l: '',
        type: '',
        t: ''
      }
      key.l = a
      key.t = b
      if (a === 0 || b === 0 || a === (this.width + 1) || b === (this.height + 1)) {
        key.type = 1
      } else {
        key.type = 0
      }
      this.list.push(key)
    },
    getred () {
      this.red.l = parseInt(Math.random() * this.width) + 1
      this.red.t = parseInt(Math.random() * this.height) + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Snake div{
  width: 8px;
  height: 8px;
  float: left;
  border: 1px solid #fff;
  font-size: 12px;
}
.Snake div.qiang{
  border: 1px solid #000;
}
.Snake div.red{
  background: red;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Snake.vue